import { Configuration, Modalidad, ModalidadApi } from '@/shared/formalizacion-client';
import { AxiosResponse } from 'axios';
import { Store } from 'vuex';

export default class ModalidadService extends ModalidadApi {
  constructor(microserviceConfigFormalizacion: Configuration, private store: Store<any>) {
    super(microserviceConfigFormalizacion);
  }

  private get modalidad(): Modalidad {
    return this.store.getters.modalidad;
  }

  public getModalidad(clave: string): Promise<AxiosResponse<Modalidad>> {
    const response = super
      .getModalidad(clave)
      .then(res => {
        this.store.commit('setModalidad', res.data);
        return Promise.resolve(res);
      })
      .catch(err => {
        return Promise.reject(err);
      });
    return response;
  }

  public getActualModalidad(): Modalidad {
    return this.modalidad;
  }

  public getActualModalidadClave(): string {
    return this.modalidad.clave;
  }
}
